import StdForm from '@shared/components/forms/auto-form/std-form/std-form.vue';
import { Component, Prop, Watch } from 'vue-property-decorator';
import EntityTableProvider from '@shared/components/tables/entity-table-provider/entity-table-provider.vue';
import EntityTable from '@shared/components/tables/entity-table/entity-table.vue';
import BpcPageTitle from '@shared/layouts/components/page-title/page-title.vue';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import EntityDeleteModalProvider from '@shared/components/modals/entity-delete-modal-provider/entity-delete-modal-provider.vue';
import ConfirmationModal from '@shared/components/modals/confirmation-modal/confirmation-modal.vue';
import { ValidationObserver } from 'vee-validate';
import { mixins } from 'vue-class-component';
import AbstractTable from '@shared/components/tables/abstract-table/abstract-table';
import StdFilter from '@shared/components/filters/std-filter/std-filter.vue';
import { library } from '@fortawesome/fontawesome-svg-core';
import { faSync } from '@fortawesome/free-solid-svg-icons';
import { faEye } from '@fortawesome/free-solid-svg-icons';
import { Message } from '@communications/interfaces/message';
import { Observable } from 'rxjs';
import BPCGenericApiResponse from '@core/interfaces/bpc-generic-api-response';
import AuthorizationHelper from '@auth/services/authorization.helper';
import store from '@app/store';
import { Route } from 'vue-router';
import DrawerModal from '@shared/components/modals/drawer-modal/drawer-modal.vue';
import SendMessageUsingTemplateMixin from '@shared/components/tables/abstract-table/send-message-using-template-mixing';

library.add(faSync);
library.add(faEye);

@Component({
  name: 'bpc-mailbox-table',
  components: {
    'bpc-entity-table-provider': EntityTableProvider,
    'bpc-entity-table': EntityTable,
    'bpc-page-title': BpcPageTitle,
    'font-awesome-icon': FontAwesomeIcon,
    'bpc-entity-delete-modal-provider': EntityDeleteModalProvider,
    'bpc-confirmation-modal': ConfirmationModal,
    'bpc-std-form': StdForm,
    'bpc-std-filter': StdFilter,
    ValidationObserver,
    'bpc-drawer-modal': DrawerModal,
  },
})
export default class MailboxTable extends mixins(AbstractTable, SendMessageUsingTemplateMixin) {
  @Prop(String) readonly displayConfigName: string;
  @Prop(String) readonly title: string;
  @Prop(String) readonly subtitle: string;
  @Prop({ type: Boolean, default: false }) readonly profileMailbox: boolean;

  public entity: Message = null;
  public entityName = 'message';
  public pluralEntityName = 'messages';
  public rowEntity = {};

  public flagsToCheckBeforeLoadEntities: string[] = [
    'configLoaded',
    'paginationLoaded',
    'orderLoaded',
    'urlParametersLoaded',
  ];

  get translationModalTabContent() {
    return this.$t('messages.message.label');
  }
  get translationModalTabReceivers() {
    return this.$t('messages.receivers.label');
  }

  public customPageActions = {
    create: {
      activated: false,
      type: 'action',
      icon: 'plus',
      variant: 'success',
      text: 'send-new',
      show: true,
      event: 'create',
      selectElements: false,
      tag: 'left',
      permissions: ['store'],
    },
  };

  customRowActions = {
    show: {
      activated: false,
      type: 'action',
      icon: 'eye',
      show: true,
      event: 'show',
      text: 'show',
      permissions: ['show'],
    },
  };

  get rowActions() {
    return {
      ...this.defaultRowActions,
      ...this.customRowActions,
    };
  }

  onRowAction($event: { event: string; item: any }) {
    switch ($event.event) {
      case 'delete':
        this.onDelete($event.item);
        break;
      case 'soft-delete':
        this.onSoftDelete($event.item);
        break;
      case 'recover':
        this.onRecover($event.item);
        break;
      case 'edit':
        this.onEdit($event.item);
        break;
      case 'show':
        this.onShow($event.item);
        break;
    }
    console.log('Row action event >>> ' + $event.event);
  }

  // For check if the user logged is owner of the item (it's executed by each item)
  extendUpdateRowActions(entity) {
    const contactId = store.getters['auth/contactId']({
      tenantId: this.$authService.getTenantId(),
    });
    const isOwner = entity.sender_id == contactId;
    entity.actions.delete.activated = isOwner;
    entity.actions.recover.activated = isOwner;
    entity.actions.softDelete.activated = isOwner;
  }

  get messageTitle() {
    return this.rowEntity && this.rowEntity['title']
      ? this.rowEntity['title']
      : this.$t('messages.default_title.label');
  }

  get messageBody() {
    return this.rowEntity && this.rowEntity['message'] ? this.rowEntity['message'] : '';
  }

  get messageReceivers() {
    return this.rowEntity && this.rowEntity['receivers'] ? this.rowEntity['receivers'] : [];
  }

  get selectedEntityRow() {
    return this.rowEntity ? this.rowEntity : {};
  }

  get unreadMessages() {
    return this.$store.getters['message/unreadMessages'];
  }

  getModalTitle() {
    return (
      this.$t('global.modals.send') + ' ' + this.$t('global.models.' + this.entityName + '.name')
    );
  }

  onShow(e) {
    console.log('clickOnEdit', e);
    this.rowEntity = e.item;
    this.$bvModal.show('show-message-modal');

    const markAsReadMessages = this.$route.meta['markAsReadMessages'];

    if (e.item.status === 'unread' && markAsReadMessages) {
      const updateMessageObservable: Observable<BPCGenericApiResponse> = this.$bpcApi.put(
        `${this.$bpcApiRouteHelper.getEntityPath('message')}/${e.item.id}/mark-as-read`,
        e.item,
        null,
      );

      updateMessageObservable.subscribe(
        (res: BPCGenericApiResponse) => {
          // this.$bpcMessage.showSuccessMessage({ text: 'global.generic.successful_action' });
          this.$refs.provider.getEntities();
        },
        error => {
          this.$bpcMessage.showErrorMessage({ text: 'global.generic.error_update_action' });
        },
        () => {
          this.$store.dispatch('message/getMessages');
        },
      );
    }
  }

  onCloseShowMessageModal() {
    this.$bvModal.hide('show-message-modal');
    this.rowEntity = {};
  }

  onNew() {
    if (!this.emitOnNew) {
      this.entity = null;
      this.showForm = true;
      // this.$bvModal.show('modal-resource-form');
      this.showSendMessageUsingTemplateDrawer = true;
      setTimeout(() => {
        this.disabledForm = false;
      });
    } else {
      this.$emit('on-new');
    }
  }

  @Watch('unreadMessages')
  onNewUnreadMessages() {
    this.$refs.provider.getEntities();
  }

  /* Lifecycle hooks */

  // created() {
  //   this.messageTypeDisplayConfigName = this.displayConfigName;
  // }
  // mounted() {}
  // updated() {}
  // destroyed() {}
}
